import { endpoints } from '../../Constants';
import { authHeader } from '../../Helpers';
import handleResponse from '../helpers';

const cityServices = {
	listCities,
	listStates,
	addCity,
};

function listStates() {
	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(endpoints.STATE_LIST, requestOptions).then(handleResponse);
}

function listCities() {
	const requestOptions = {
		method: 'GET',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
	};
	return fetch(endpoints.CITY_LIST, requestOptions).then(handleResponse);
}

function addCity(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints.ADD_CITY, requestOptions).then(handleResponse);
}

export default cityServices;
